// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1398":"79c3cc5a","1852":"0bcc666e","5520":"f18166a0"}[chunkId] + ".chunk.css";
};